<template>
    <div id="cloud" class="cloud">
        <section id="cloud-entry-wrap" class="cloud-entry-wrap">
            <div class="cloud-entry">
                <div class="container">
                    <h1 class="title">{{ $t( 'homepage.entryTitle' ) }}</h1>
                    <p class="subtitle">{{ $t( 'homepage.entrySubTitle' ) }}</p>
                    <reo-common-button
                        class="jump-to"
                        :style="anchorStyle"
                        v-anchor:#join
                        @click="sendGaEvent('Cloud Storage Service-subscribe now')"
                    >
                        <template #label>
                            <span class="label">{{ $t('basicPlan.subscribeNow') }}</span>
                        </template>
                    </reo-common-button>
                </div>
            </div>
        </section>

    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import CloudLogo from 'IMAGE/homepage/cloud-logo.png';
import { config } from 'CONFIG';
import paymentMethods from '@/config/paymentMethods';
import router from '@/router';
import ReoCommonButton from '@/components/ReoCommonButton.vue';
import reolinkGa from '@/common/js/gtagPageview';

export default Vue.extend({

    components: {
        ReoCommonButton
    },

    data () {

        return {

            planList: [] as any[],
            paymentMethods,
            config,
            CloudLogo,

        };

    },

    methods: {

        async navigateTo( btnType: 'login' | 'signup' | 'library' ) {

            switch ( btnType ) {

                case 'login':{

                    window.location.href = this.loginDashboardUrl;
                    break;

                }
                case 'signup':{

                    window.location.href = this.signupUrl;
                    break;

                }
                case 'library':{

                    try {

                        await router.push({
                            name: 'library'
                        });

                    } catch ( error ) {

                        console.error( error );

                    }

                    break;

                }

            }

        },
        sendGaEvent( event: string ) {

            reolinkGa.sendSimpleEvent( event );

        }

    },

    computed: {

        loginDashboardUrl () {

            return config.accountCenterLoginUrl + '?redirect=' + window.location.origin + '/user/cloud-library/';

        },

        signupUrl () {

            return config.accountCenterLoginUrl + '?redirect=' + window.location.origin + '/user/cloud-library/#signup';

        },

        userId(): boolean {

            return this.$store.getters.userId;

        },

        isMobile(): boolean {

            return this.$store.getters.isMobile;

        },

        lang(): string  {

            return this.$store.getters.lang;

        },

        userStatus (): string {

            return this.$store.state.user.status;

        },

        anchorStyle(): Record<string, string> {

            return { 'visibility': this.$route.name === 'cloud-plan' ? 'visible' : 'hidden' };

        },

    }

});

</script>

<style scoped rel="stylesheet/css" lang="less">

.cloud {
    color: #333;
    text-align: center;
    font-weight: 400;
    line-height: 1.2;
    .cloud-entry {
        padding: 60px 0 0;
        background: url(IMAGE/homepage/home.jpg) #f3f4f9 top
            center no-repeat;
        background-size: 100% auto;
        min-height: 500px;
        .mobile({
            height: 390px;
            min-height: auto;
            box-sizing: border-box;
            padding: 32px 20px;
            background-image: url(IMAGE/homepage/home-m.jpg);
            background-position: center;
            background-size: auto 105%; /* 高度105%，宽度自动 */
        });

        .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0;
            position: relative;
            .cloud-logo {
                margin-bottom: 0.2rem;
                img {
                    height: 50px;
                }
            }
            .title {
                font-size: 42px;
                font-weight: 600;
                margin-bottom: 4px;
                .mobile({
                    font-size: 28px;
                });
            }
            .subtitle,.date {
                font-size: 16px;
                font-weight: 400;
            }
            .entry-box {
                margin-top: 24px;
                display: flex;
                justify-content: center;
                gap: 20px;
                &.is-login div+div {
                    display: none;
                }
            }

            .jump-to {
                margin-top: 24px;
                .label{
                    font-size: 17px;
                    font-weight: 500;
                    line-height: 21px;
                }
            }
        }
    }

}

/* entry --E */

</style>
